@if (isShowing$ | async) {
  <div class="splash-screen" @fadeInOut>
    <div class="splash-overlay"></div>
    <div class="splash-content">
      <div class="logo-section">
        <app-svg-icon
          [iconName]="'deeproots-logo-v2.svg'"
          [width]="'100%'"
          [height]="'130'"
        ></app-svg-icon>
      </div>

      <div class="message-section">
        <h2 class="message-text">{{ message$ | async }}</h2>
      </div>

      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>
  </div>
}
